export const az = {
  title: 'Ağac örtüyünün hündürlüyü',
  subtitle: '2000/2020, 30 m, global, UMD/NASA GEDI',
  download_data: '',
  learn_more: 'https://glad.umd.edu/dataset/gedi/',
  content: [
    {
      label: 'Funksiya',
      value: '2000 və 2020-ci illərdə qlobal meşə kanopunun hündürlüyünü göstərin.',
    },
    {
      label: 'Qətmə',
      value: '30 m',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal, 52°N-dən yuxarı prototip məlumatları ilə',
    },
    {
      label: 'Mənbə',
      value:
        'Potapov, P., Li, X., Hernandez-Serna, A., Tyukavina, A., Hansen, M.C., Kommareddy, A., Pickens, A., Turubanova, S., Tang, H., Silva, C.E. and Armston, J., 2021. Mapping global forest canopy height through integration of GEDI and Landsat data. Remote Sensing of Environment, 253, p.112165. https://doi.org/10.1016/j.rse.2020.112165',
    },
    {
      label: 'Tezlik',
      value: '',
    },
    {
      label: 'Məzmun tarixi',
      value: '2000 və 2020-ci il',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'Qlobal meşə hündürlüyü xəritəsi GEDI məlumat keyfiyyəti və Landsat data mövcudluğu ilə bağlı məlum məsələlər olan prototip məhsuludur. GeDI data temperate və subtropical mountain otlaqları daxilində yamaclarda meşə hündürlüyü overestiilope, məsələn, Yeni Zelandiya və Lesotho. Şəhər və qəsəbələr üzərindəki ağac hündürlüyü binanın hündürlüyü ilə çaşqınlıq yarana bilər, çünki GEDI məlumatları bitki örtüyünün hündürlüyü ilə insan istehsalı olan obyektlər arasında ayrı-seçkilik etmir. GeDI kalibrləmə qeyri-müəyyənlikləri (konkret olaraq geolokasiya dəqiqliyi və torpaq səthinin hündürlük hesablaması) xəritənin bəzi səhvlərinə görə məsuliyyət daşıya bilər. Ağac hündürlüyü modeli 30m-dən yuxarı doymuş və ən hündür ağacların hündürlüyünü kifayət qədər təmsil edə bilməz. Qlobal məhsul gələcəkdə əksər məsələləri həll etmək üçün yenilənəcək.',
    },
    {
      label: 'Lisenziya',
      value: '',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Yeni, 30-m spatial qətnamə qlobal meşə canopy hündürlük xəritəsi Qlobal Ekosistem Dinamikası Araşdırma (GEDI) lidar meşə strukturu ölçüləri və Landsat analiz hazır data vaxt seriyası inteqrasiya vasitəsilə hazırlanmışdır. NASA GEDI 2019-cu ilin aprel ayından beynəlxalq kosmik stansiyada işləyən kosmik lidar alətidir. 52°N və 52°S arasında olan meşə kanopu hündürlüyü də daxil olmaqla, bitki örtüyünün nöqtə əsaslı ölçülərini təmin edir. Maryland Universitetinin Global Land Analysis and Discover komandası (UMD GLAD) 2019 Landsat analiz-hazır vaxt seriyalı məlumatlar (Landsat ARD) ilə bu günə qədər mövcud olan GEDI məlumatlarını (aprel-oktyabr 2019) birləşdirmişdir. GeDI RH95 (nisbi hündürlüyü 95%) metri modelin kalibri üçün istifadə edilmişdir. Səthi fenologiyanı təmsil edən Landsat çox temporal metrikası qlobal meşə hündürlüyü modelləşdirilməsi üçün müstəqil dəyişənlər kimi xidmət edir. "hərəkət edən pəncərə" yerli kalibrlənmiş və tətbiq edilmiş regressiya ağac ansamblı modeli meşə hündürlüyünün yüksək keyfiyyətinin proqnozlaşdırılması və qlobal xəritə ardıcıllığını təmin etmək üçün həyata keçirildi. Bu model qlobal meşə hündürlüyü prototip xəritəsini yaratmaq üçün boreal bölgələrdə (GEDI məlumat aralığından kənarda) ekstrapolyasiya edilmişdir.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Potapov, P., Li, X., Hernandez-Serna, A., Tyukavina, A., Hansen, M.C., Kommareddy, A., Pickens, A., Turubanova, S., Tang, H., Silva, C.E. and Armston, J., 2021. Mapping global forest canopy height through integration of GEDI and Landsat data. Remote Sensing of Environment, 253, p.112165. https://doi.org/10.1016/j.rse.2020.112165. Accessed through Global Forest Watch on 14/02/2025. www.globalforestwatch.org.',
  },
};
